import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Skeleton } from "@telia/teddy";
import _isEmpty from "lodash/isEmpty";
import { useSelector, useDispatch } from "react-redux";
import { OfferingCode, RootState, SubscriptionWithGetIT } from "../../../../../models";
import { isTypeLoading } from "../../../loading/state/selectors";

import "./ExtraSubscriptionModal.less";
import { getSubscriptions } from "../../../subscription-listing/state/actions";
import { SUBSCRIPTION_LISTING_GET_SUBSCRIPTIONS } from "../../../subscription-listing/state/actionTypes";
import { getTeliaTryggSubscriptions } from "../../../subscription-listing/state/selectors";
import SubscriptionCardList from "../../components/organisms/SubscriptionCardList/SubscriptionCardList";
import { getNumberOfSubscriptionsInCart } from "../../state/selectors/cartSelectors";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (offeringCode: OfferingCode, quantity: number) => void;
    setIsOpen: (isOpen: boolean) => void;
}

const TeliaTryggModal: React.FC<Props> = ({ onClose, onSubmit, isOpen, setIsOpen }) => {
    const dispatch = useDispatch();
    const [selectedSubscription, setSelectedSubscription] = useState("");
    const isFetchingSubscriptions = useSelector((state: RootState) =>
        isTypeLoading(state, SUBSCRIPTION_LISTING_GET_SUBSCRIPTIONS),
    );
    const teliaTryggOfferings = useSelector((state: RootState) => getTeliaTryggSubscriptions(state));

    const numberOfSelectedSubscriptionInCart = useSelector((state: RootState) =>
        getNumberOfSubscriptionsInCart(state, selectedSubscription as OfferingCode),
    );

    useEffect(() => {
        if (_isEmpty(teliaTryggOfferings)) {
            dispatch(getSubscriptions());
        }
    }, []);

    return (
        <Modal open={isOpen}>
            <Modal.Overlay className="extra-subscription-modal__container">
                <Modal.Content className="extra-subscription-modal__content">
                    <Modal.Group className="extra-subscription-modal__header" variant="title">
                        <Modal.Title as="h3">Ekstra trygghet</Modal.Title>
                        <Modal.Close aria-label="lukk" slot="floating" onClick={() => setIsOpen(false)} />
                        <Modal.Description className="extra-subscription-modal__description">
                            Beskytt deg mot svindel og ID-tyveri. Helt valgfritt – du kan endre valget senere på Mine
                            Sider.
                        </Modal.Description>
                    </Modal.Group>
                    {isFetchingSubscriptions &&
                        Array.from({ length: 2 }).map((_unused, index) => (
                            <Box width="100%" key={index}>
                                <Skeleton
                                    radius="sm"
                                    loading
                                    style={{ height: "160px", width: "100%", marginBottom: "1rem" }}
                                />
                            </Box>
                        ))}
                    {teliaTryggOfferings.length > 0 && (
                        <>
                            <SubscriptionCardList
                                idPrefix="single"
                                isPDP={false}
                                footerButton={false}
                                subscriptions={teliaTryggOfferings as SubscriptionWithGetIT[]}
                                selectedSubscriptionCode={selectedSubscription.split(".")[0]}
                                numberOfSubscriptions={1}
                                showTextTypes={["info", "checkout"]}
                                showOnlyGivenTextTypes
                                priceInfo={["/md."]}
                                onOpenSubscription={(offeringCode, icim) => {
                                    const pricePlan = `${offeringCode}.${icim || "REGULAR"}`;
                                    if (offeringCode === selectedSubscription) {
                                        setSelectedSubscription("");
                                        return;
                                    }
                                    setSelectedSubscription(pricePlan);
                                }}
                            />
                        </>
                    )}
                    <Modal.Group className="extra-subscription-modal__footer" variant="action">
                        <Modal.Close slot="content">
                            <Button variant="secondary" onClick={onClose}>
                                <span>Tilbake</span>
                            </Button>
                        </Modal.Close>
                        <Button
                            variant="primary"
                            loading={false}
                            onClick={() =>
                                onSubmit(selectedSubscription as OfferingCode, numberOfSelectedSubscriptionInCart + 1)
                            }
                            disabled={!selectedSubscription || isFetchingSubscriptions}
                        >
                            <span>Legg til Telia Trygg</span>
                        </Button>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default TeliaTryggModal;
